'use client';

import { useState, useEffect } from 'react';


interface FormData {
  name: string;
  email: string;
  phone: string;
  revenue: string;
  challenge: string;
}

const BookCallSection = () => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [formData, setFormData] = useState<FormData>({
    name: '',
    email: '',
    phone: '',
    revenue: '',
    challenge: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [spotsRemaining, setSpotsRemaining] = useState(3);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    setTimeout(() => {
      setIsSubmitting(false);
      setIsSubmitted(true);
      setFormData({
        name: '',
        email: '',
        phone: '',
        revenue: '',
        challenge: ''
      });
    }, 1500);
  };

  if (!isHydrated) {
    return (
      <section data-component-id="src/app/landing-page/components/BookCallSection.tsx:58:6" data-component-path="src/app/landing-page/components/BookCallSection.tsx" data-component-line="58" data-component-file="BookCallSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22book-call%22%2C%22className%22%3A%22py-16%20md%3Apy-24%20bg-background%22%7D" id="book-call" className="py-16 md:py-24 bg-background">
        <div data-component-id="src/app/landing-page/components/BookCallSection.tsx:59:8" data-component-path="src/app/landing-page/components/BookCallSection.tsx" data-component-line="59" data-component-file="BookCallSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-4xl%20mx-auto%20px-6%22%7D" className="max-w-4xl mx-auto px-6">
          <div data-component-id="src/app/landing-page/components/BookCallSection.tsx:60:10" data-component-path="src/app/landing-page/components/BookCallSection.tsx" data-component-line="60" data-component-file="BookCallSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-surface%20rounded-lg%20p-8%20shadow-video%20animate-pulse%22%7D" className="bg-surface rounded-lg p-8 shadow-video animate-pulse">
            <div data-component-id="src/app/landing-page/components/BookCallSection.tsx:61:12" data-component-path="src/app/landing-page/components/BookCallSection.tsx" data-component-line="61" data-component-file="BookCallSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22h-8%20bg-border%20rounded%20w-3%2F4%20mx-auto%20mb-4%22%7D" className="h-8 bg-border rounded w-3/4 mx-auto mb-4" />
            <div data-component-id="src/app/landing-page/components/BookCallSection.tsx:62:12" data-component-path="src/app/landing-page/components/BookCallSection.tsx" data-component-line="62" data-component-file="BookCallSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22h-4%20bg-border%20rounded%20w-1%2F2%20mx-auto%20mb-8%22%7D" className="h-4 bg-border rounded w-1/2 mx-auto mb-8" />
            <div data-component-id="src/app/landing-page/components/BookCallSection.tsx:63:12" data-component-path="src/app/landing-page/components/BookCallSection.tsx" data-component-line="63" data-component-file="BookCallSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22space-y-4%22%7D" className="space-y-4">
              <div data-component-id="src/app/landing-page/components/BookCallSection.tsx:64:14" data-component-path="src/app/landing-page/components/BookCallSection.tsx" data-component-line="64" data-component-file="BookCallSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22h-12%20bg-border%20rounded%22%7D" className="h-12 bg-border rounded" />
              <div data-component-id="src/app/landing-page/components/BookCallSection.tsx:65:14" data-component-path="src/app/landing-page/components/BookCallSection.tsx" data-component-line="65" data-component-file="BookCallSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22h-12%20bg-border%20rounded%22%7D" className="h-12 bg-border rounded" />
              <div data-component-id="src/app/landing-page/components/BookCallSection.tsx:66:14" data-component-path="src/app/landing-page/components/BookCallSection.tsx" data-component-line="66" data-component-file="BookCallSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22h-12%20bg-border%20rounded%22%7D" className="h-12 bg-border rounded" />
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section data-component-id="src/app/landing-page/components/BookCallSection.tsx:75:4" data-component-path="src/app/landing-page/components/BookCallSection.tsx" data-component-line="75" data-component-file="BookCallSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22book-call%22%2C%22className%22%3A%22py-16%20md%3Apy-24%20bg-background%22%7D" id="book-call" className="py-16 md:py-24 bg-background">
      <div data-component-id="src/app/landing-page/components/BookCallSection.tsx:76:6" data-component-path="src/app/landing-page/components/BookCallSection.tsx" data-component-line="76" data-component-file="BookCallSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-4xl%20mx-auto%20px-6%22%7D" className="max-w-4xl mx-auto px-6">
      </div>
    </section>
  );
};

export default BookCallSection;